import deleteApi from 'modules/api/services/delete'
import postApi from 'modules/api/services/post'
import putApi from 'modules/api/services/put'
import { prepareOptionsApiUtil } from 'modules/api/utils'
import openErrorBannerAction from 'modules/banner/actions/open-error'
// import afterDeleteReduxAction from 'modules/legacy/after-delete'
// import sendErrorAction from 'modules/error/send'
import createReduxAction from 'modules/redux/actions/create'
import setReduxAction from 'modules/redux/actions/set'
import REDUX_ACTION from 'modules/redux/constants/action'
import REDUX_NON_DIRECTLY_SAVABLE from 'modules/redux/constants/non-directly-savable'
import { REDUX_STATUS } from '@gymaholic/packages'
import isSavingReduxSelector from 'modules/redux/selectors/is-saving'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import getSavableAssociationKeysReduxUtil from 'modules/redux/utils/get-savable-association-keys'
import getSavableDataReduxUtil from 'modules/redux/utils/get-savable-data'
import getUpdatedDataReduxUtil from 'modules/redux/utils/get-updated-data'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import hasChangedReduxUtil from 'modules/redux/utils/has-changed'
import beforeSaveReduxHookUtil from 'modules/redux/utils/hooks/before-save'
import isInstanceReduxUtil from 'modules/redux/utils/is-instance'
import isNewReduxUtil from 'modules/redux/utils/is-new'
import isTemporaryIdReduxUtil from 'modules/redux/utils/is-temporary-id'
import addRequestNetworkAction from 'modules/training/modules/network/actions/add-request'
import incrementRetryCountNetworkAction from 'modules/training/modules/network/actions/increment-retry-count'
import removeRequestNetworkAction from 'modules/training/modules/network/actions/remove-request'
import {
  NETWORK_ACTION,
  NETWORK_PATH
} from 'modules/training/modules/network/constants'
import getRequestsNetworkSelector from 'modules/training/modules/network/selectors/get-requests'
import isConnectedNetworkSelector from 'modules/training/modules/network/selectors/is-connected'
import setUtil from 'utils/set'
import { getObjectUtil } from 'packages/src'

const METHOD_FN = {
  POST: postApi,
  PUT: putApi,
  DELETE: deleteApi
}

/**
 * Sets the given `path` status as success and set the data.
 * @param {Object} action
 *        {number} type
 *        {Object} action.payload
 *        {string} action.payload.path
 *        {Object} [action.payload.data]
 */
function saveSuccessReduxAction (action) {
  return {
    type: action.type + '_SUCCESS',
    payload: action.payload,
    reduxType: REDUX_ACTION.SAVE_SUCCESS
  }
}

/**
 * Sets the given `path` status as error and set the error.
 * @param {Object} action
 *        {number} type
 *        {Object} action.payload
 *        {string} action.payload.path
 *        {Object} action.payload.error
 */
function saveErrorReduxAction (action) {
  return (dispatch) => {
    // dispatch(
    //   sendErrorAction(action.payload.error)
    // )
    dispatch({
      type: action.type + '_ERROR',
      reduxType: REDUX_ACTION.SAVE_ERROR,
      payload: action.payload
    })
  }
}

/**
 * Sets the given `path` status as saving.
 * @param {Object} action
 *        {string} action.type
 *        {Object} action.payload
 *        {string} action.payload.path
 */
function savingReduxAction (action) {
  return {
    type: action.type,
    payload: action.payload,
    reduxType: REDUX_ACTION.SAVE
  }
}

function getDeepUpdatedInstance (instance, state) {
  const associationPointerKeys = getSavableAssociationKeysReduxUtil(instance)
  if (associationPointerKeys.length) {
    instance = associationPointerKeys.reduce((newInstance, associationPointerKey) => {
      const associationPointer = getValueReduxUtil(
        newInstance, associationPointerKey
      )
      // If the instance has no association to save, no-op
      // e.g. Post.attachment is not always necessary
      if (!associationPointer) {
        return newInstance
      }
      if (Array.isArray(associationPointer)) {
        newInstance = setUtil(
          newInstance,
          `changed.${associationPointerKey}`,
          associationPointer.map(
            associationPointerElem => getDeepUpdatedInstance(
              getObjectUtil(state, getPathReduxUtil(associationPointerElem)), state
            )
          )
        )
      } else {
        newInstance = setUtil(
          newInstance,
          `changed.${associationPointerKey}`,
          getDeepUpdatedInstance(
            getObjectUtil(state, getPathReduxUtil(associationPointer)), state
          )
        )
      }
      return newInstance
    }, instance)
  }
  return getSavableDataReduxUtil(instance)
}

function sendRemoteInstanceReduxAction (action) {
  return async (dispatch, getState) => {
    const { payload } = action
    let {
      domainListPath,
      domainPath,
      endpoint,
      path,
      method,
      options
    } = payload

    console.debug('sendRemoteInstanceReduxAction: payload=', payload)

    dispatch(
      savingReduxAction({
        type: action.type,
        payload: {
          path
        }
      })
    )

    try {
      const instance = getObjectUtil(getState(), path)
      let dataToSave = getDeepUpdatedInstance(instance, getState())
      dataToSave = beforeSaveReduxHookUtil(dataToSave)
      console.debug('sendRemoteInstanceReduxAction: dataToSave=', dataToSave)
      if (method) {
        method = METHOD_FN[method]
      } else if (!isNewReduxUtil(instance)) {
        method = putApi
      } else {
        method = postApi
      }
      const response = await method(endpoint, dataToSave)
      console.debug('sendRemoteInstanceReduxAction: response=', response)
      const data = Object.values(response.data)[0]
      if (data) {
        dispatch(
          createReduxAction({
            type: action.type + '_CREATE_AFTER_SAVE',
            payload: {
              domainListPath,
              domainPath,
              data: {
                data,
                status: REDUX_STATUS.SUCCESS
              },
              existingInstance: instance,
              options
            }
          })
        )
      } else {
        // Delete the instance
        // dispatch(
        //   afterDeleteReduxAction({
        //     type: action.type,
        //     payload: {
        //       instance
        //     }
        //   })
        // )
      }
      return response
    } catch (error) {
      dispatch(
        saveErrorReduxAction({
          type: action.type,
          payload: {
            path,
            error
          }
        })
      )
      throw error
    }
  }
}

function sendRemoteDataReduxAction (action) {
  return async (dispatch, getState) => {
    const { payload } = action
    let { options } = action
    const {
      endpoint,
      data,
      path,
      domainPath
    } = payload
    let {
      method
    } = payload
    dispatch(
      savingReduxAction({
        type: action.type,
        payload: {
          path
        }
      })
    )
    try {
      options = prepareOptionsApiUtil(options, getState())
      method = method
        ? METHOD_FN[method]
        : postApi
      const response = await method(endpoint, data, options)
      // If it's saving a single instance, update the instance
      const domainOrInstance = getObjectUtil(getState(), path)
      const responseData = response.data && Object.values(response.data)[0]
      if (isInstanceReduxUtil(domainOrInstance) && responseData) {
        dispatch(
          createReduxAction({
            type: action.type + '_UPDATE_AFTER_SAVE',
            payload: {
              domainPath,
              data: {
                data: responseData,
                status: REDUX_STATUS.SUCCESS
              },
              existingInstance: domainOrInstance
            }
          })
        )
      }
      dispatch(
        saveSuccessReduxAction({
          type: action.type,
          payload: {
            path,
            options
          }
        })
      )
      return response
    } catch (error) {
      dispatch(
        saveErrorReduxAction({
          type: action.type,
          payload: {
            path,
            error
          }
        })
      )
      dispatch(
        openErrorBannerAction(error)
      )
      throw error
    }
  }
}

function sendRemoteReduxAction (action) {
  if (action.payload.data) {
    return sendRemoteDataReduxAction(action)
  }
  return sendRemoteInstanceReduxAction(action)
}

let isSendingRequests = false

function sendQueuedRequestsReduxAction (isTraversingTheQueue) {
  return async (dispatch, getState) => {
    // If we're already going through the queue, no-op
    // It will it go to the next request once this one is done
    if (!isTraversingTheQueue && isSendingRequests) {
      console.debug('sendQueuedRequestsReduxAction: [NOOP] already sending request')
      return
    }
    let requests = getRequestsNetworkSelector()(getState())
    console.debug(`sendQueuedRequestsReduxAction: requests length    ${requests.length}`)
    if (!requests.length) {
      console.debug('sendQueuedRequestsReduxAction: [NOOP] no requests')
      return
    }
    // If we're not connected to the server, no-op
    if (!isConnectedNetworkSelector()(getState())) {
      console.debug('sendQueuedRequestsReduxAction: [NOOP] not connected')
      return
    }
    // Remove the requests who has been tried 5 times
    const request = { ...requests[0] }
    const { action } = request
    console.debug('sendQueuedRequestsReduxAction: sending request with action=', action)
    try {
      isSendingRequests = true
      await dispatch(
        sendRemoteReduxAction(action)
      )
      dispatch(
        removeRequestNetworkAction(action)
      )
    } catch (error) {
      // If we're not able to reach the server, increment the retry count
      const message = getObjectUtil(error, 'message')
      if (/timeout|network/gi.test(message)) {
        dispatch(
          incrementRetryCountNetworkAction(action)
        )
      } else {
        // TODO Show the error
        // Remove the request
        dispatch(
          removeRequestNetworkAction(action)
        )
      }
      // throw error
    }
    // Update the requests that have been tried too many times
    requests = getRequestsNetworkSelector()(getState())
    const filteredRequests = requests.filter(request => request.retryCount < 20)
    if (requests.length !== filteredRequests.length) {
      dispatch(
        setReduxAction({
          type: NETWORK_ACTION.DELETE_FAILED_REQUESTS,
          payload: {
            path: NETWORK_PATH.REQUESTS,
            value: filteredRequests
          }
        })
      )
    }
    // If there is other requests, send them
    if (requests.length) {
      return dispatch(
        sendQueuedRequestsReduxAction(true)
      )
    }
    isSendingRequests = false
  }
}

function hasUnsavedForeignKeys (instance) {
  const data = getUpdatedDataReduxUtil(instance)
  return Object.keys(data)
    .some((key) => {
      const value = data[key]
      return (
        key.endsWith('Id') &&
        value &&
        isTemporaryIdReduxUtil(value)
      )
    })
}

function saveReduxAction (action) {
  return async (dispatch, getState) => {
    const { payload } = action
    const {
      path,
      data,
      method
    } = payload
    const instance = getObjectUtil(getState(), path)
    // If it's already saving, no-op
    if (!data && isSavingReduxSelector(path)(getState())) {
      console.debug(`saveReduxAction: [NOOP] already saving ${path}`)
      return
    }

    // If the instance has not changed, no-op
    if (
      !data &&
      !method &&
      isInstanceReduxUtil(instance) &&
      !hasChangedReduxUtil(instance)
    ) {
      console.debug(`saveReduxAction: [NOOP] not changed ${path}`)
      return
    }

    // If the instance should not be saved directly, no-op
    // E_g. WorkoutSection, WorkoutExercise
    if (
      !data &&
      isInstanceReduxUtil(instance) &&
      REDUX_NON_DIRECTLY_SAVABLE.includes(instance.className)
    ) {
      console.debug(`saveReduxAction: [NOOP] non savable ${path}`)
      return
    }

    // If the instance has unsaved foreign keys
    if (
      isInstanceReduxUtil(instance) &&
      hasUnsavedForeignKeys(instance)
    ) {
      console.debug(`saveReduxAction: [NOOP] foreign keys unsaved ${path}`)
      return
    }

    // If the request can't be queued, do it now
    if (data) {
      return dispatch(
        sendRemoteReduxAction(action)
      )
    }

    // Add the request to the queue
    console.debug(`saveReduxAction: adding request for ${path}`)
    dispatch(
      addRequestNetworkAction(action)
    )
    // Throw an error if we require a server response but the user is not
    // connected
    if (
      !data &&
      !isConnectedNetworkSelector()(getState()) &&
      !isInstanceReduxUtil(instance)
    ) {
      console.warn(`saveReduxAction: [WARN] connection not available but needed ${path}`)
      dispatch(
        saveErrorReduxAction({
          type: action.type,
          payload: {
            path,
            error: 'not connected'
          }
        })
      )
      return
    }
    // Send the requests from the queue
    dispatch(
      sendQueuedRequestsReduxAction()
    )
  }
}

export {
  savingReduxAction,
  saveErrorReduxAction,
  saveSuccessReduxAction,
  sendQueuedRequestsReduxAction
}
export default saveReduxAction
